import { render, staticRenderFns } from "./2DLOCAL.vue?vue&type=template&id=4d0ff19c"
import script from "./2DLOCAL.vue?vue&type=script&lang=js"
export * from "./2DLOCAL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports